import Model from './model.js'
//import {RequestinProcess} from '../../helper/request.action.js'

export default {
	ReadSite: function(params) {
		Model.ModelReadSite(params)
	},
	ReadSiteAsset: function(params){
		if(params.action === 'Next') {
			params.data.url = params.self.state.nextURL;
		}
		Model.ReadSiteAsset(params)
	},
	ReadMasterSiteType: function(params){
		Model.ReadMasterSiteType(params)
	},
	ReadMasterSiteStatus: function(params){
		Model.ReadMasterSiteStatus(params)
	}
}


// WEBPACK FOOTER //
// ./src/App/topmenu/job/presenter.js